import React, { useState } from 'react';
import { portfolioCollections } from '../data/mock';

const PortfolioPage = () => {
  const [activeCollection, setActiveCollection] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);

  const getAllImages = () => {
    return portfolioCollections.flatMap(collection => 
      collection.images.map(img => ({ ...img, collection: collection.title }))
    );
  };

  const filteredImages = activeCollection === 'all' 
    ? getAllImages()
    : portfolioCollections.find(c => c.id === activeCollection)?.images || [];

  return (
    <div className="min-h-screen pt-24 md:pt-32 bg-white">
      {/* Header Section */}
      <section className="container-luxury mb-12 md:mb-20">
        <div className="max-w-2xl">
          <h1 className="section-title text-[#111111] mb-6 animate-fade-in-up">
            Portfolio
          </h1>
          <p className="body-text text-[#666666] animate-fade-in-up animation-delay-1">
            Une sélection de travaux éditoriaux, portraits artistiques et compositions minimalistes.
          </p>
        </div>
      </section>

      {/* Filter Tabs */}
      <section className="container-luxury mb-12">
        <div className="flex flex-wrap gap-8 border-b border-[#EAEAEA] pb-4">
          <button
            onClick={() => setActiveCollection('all')}
            className={`nav-link transition-all duration-300 pb-4 -mb-4 border-b-2 ${
              activeCollection === 'all' 
                ? 'text-[#111111] border-[#111111]' 
                : 'text-[#9A9A9A] border-transparent hover:text-[#111111]'
            }`}
          >
            Tous
          </button>
          {portfolioCollections.map((collection) => (
            <button
              key={collection.id}
              onClick={() => setActiveCollection(collection.id)}
              className={`nav-link transition-all duration-300 pb-4 -mb-4 border-b-2 ${
                activeCollection === collection.id 
                  ? 'text-[#111111] border-[#111111]' 
                  : 'text-[#9A9A9A] border-transparent hover:text-[#111111]'
              }`}
            >
              {collection.title}
            </button>
          ))}
        </div>
      </section>

      {/* Portfolio Grid */}
      <section className="container-luxury section-spacing">
        <div className="portfolio-grid">
          {filteredImages.map((image, index) => (
            <div
              key={image.id}
              className="group cursor-pointer animate-fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
              onClick={() => setSelectedImage(image)}
            >
              <div className="image-luxury aspect-[4/5] mb-4">
                <img
                  src={image.src}
                  alt={image.title}
                  className="grayscale"
                  loading="lazy"
                />
                <div className="image-overlay flex items-end p-6">
                  <span className="nav-link text-white">
                    Voir
                  </span>
                </div>
              </div>
              <div className="space-y-1">
                <h3 className="font-serif text-lg text-[#111111] group-hover:opacity-70 transition-opacity duration-300">
                  {image.title}
                </h3>
                <p className="caption-text">
                  {image.year}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4 animate-fade-in"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-6 right-6 nav-link text-white/70 hover:text-white transition-colors duration-300"
            onClick={() => setSelectedImage(null)}
          >
            Fermer
          </button>
          <div className="max-w-4xl max-h-[85vh] animate-fade-in-up">
            <img
              src={selectedImage.src}
              alt={selectedImage.title}
              className="max-w-full max-h-[75vh] object-contain grayscale"
            />
            <div className="mt-6 text-center">
              <h3 className="font-serif text-xl text-white mb-2">
                {selectedImage.title}
              </h3>
              <p className="caption-text text-white/60">
                {selectedImage.year}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PortfolioPage;
